import { render, staticRenderFns } from "./PagamentoDesassociarConsultoria.vue?vue&type=template&id=6a5091db"
import script from "./PagamentoDesassociarConsultoria.vue?vue&type=script&lang=js"
export * from "./PagamentoDesassociarConsultoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports